import React from 'react';

const ScoreCircle = ({ score, maxScore = 100 }) => {
  const percentage = (score / maxScore) * 100;
  const circumference = 2 * Math.PI * 54;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  const getScoreColor = (score) => {
    if (score >= 80) return '#4A5D23';
    if (score >= 60) return '#D4AF37';
    if (score >= 40) return '#B45309';
    return '#991B1B';
  };

  const getScoreLabel = (score) => {
    if (score >= 80) return 'Excellent';
    if (score >= 60) return 'Good';
    if (score >= 40) return 'Average';
    return 'Below Average';
  };

  return (
    <div className="score-circle flex flex-col items-center" data-testid="wvc-score-circle">
      <div className="relative w-[140px] h-[140px]">
        {/* SVG for circular progress */}
        <svg width="140" height="140" viewBox="0 0 120 120" className="absolute inset-0">
          {/* Background track */}
          <circle
            cx="60"
            cy="60"
            r="54"
            stroke="#E7E5E4"
            strokeWidth="8"
            fill="none"
          />
          {/* Progress arc - using separate group for rotation */}
          <g style={{ transform: 'rotate(-90deg)', transformOrigin: '60px 60px' }}>
            <circle
              cx="60"
              cy="60"
              r="54"
              stroke={getScoreColor(score)}
              strokeWidth="8"
              fill="none"
              strokeLinecap="round"
              strokeDasharray={circumference}
              strokeDashoffset={strokeDashoffset}
              style={{ transition: 'stroke-dashoffset 1s ease-out' }}
            />
          </g>
        </svg>
        {/* Score text - separate div to avoid rotation */}
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span 
            className="font-serif text-4xl font-medium text-stone-900"
            style={{ lineHeight: 1 }}
          >
            {score}
          </span>
          <span 
            className="text-[10px] font-semibold text-stone-400 tracking-widest mt-1"
          >
            WVC SCORE
          </span>
        </div>
      </div>
      <span 
        className="mt-2 px-3 py-1 rounded-full text-xs font-medium"
        style={{ 
          backgroundColor: `${getScoreColor(score)}15`,
          color: getScoreColor(score)
        }}
      >
        {getScoreLabel(score)}
      </span>
    </div>
  );
};

export default ScoreCircle;
